import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, forwardRef, isValidElement, memo, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { Loader } from '../../../Elements/Loader/index.js';
import { StyledInput } from '../../common/StyledInput.js';
import { StyledInputContainer } from '../../common/StyledInputContainer.js';
import { IconContainer, InputWrapper, MaxLengthContainer } from './styled.js';
export const Input = memo(forwardRef(function Input({ value, isLoading, success, warning, error, icon: iconProp, isActionIcon, maxLength, dataTestId, ...props }, ref) {
    const { colors } = useTheme();
    const inputDisabled = props.readOnly || props.disabled;
    const icon = useMemo(() => isValidElement(iconProp)
        ? cloneElement(iconProp, {
            color: inputDisabled ? colors.grey30_1 : colors.grey100_1,
            onClick: undefined,
        })
        : iconProp, [colors.grey100_1, colors.grey30_1, iconProp, inputDisabled]);
    const handleIconClick = useMemo(() => (isValidElement(iconProp) && 'onClick' in iconProp.props ? iconProp.props.onClick : undefined), [iconProp]);
    const handleWheel = useCallbackRef((e) => {
        if (props.type === 'number') {
            e.currentTarget.blur();
        }
    });
    return (_jsxs(StyledInputContainer, { $inputDisabled: inputDisabled, $success: success, $warning: warning, $error: error, "data-testid": dataTestId, children: [_jsxs(InputWrapper, { children: [_jsx(StyledInput, { value: value, $withIcon: isLoading || (!!iconProp && !maxLength), maxLength: maxLength, onWheel: handleWheel, ref: ref, ...props }), isLoading && (_jsx(IconContainer, { children: _jsx(Loader, { fill: colors.grey100_1, background: 'transparent' }) })), iconProp && !isLoading && !maxLength && (_jsx(IconContainer, { $inputDisabled: inputDisabled, $isActionIcon: isActionIcon, onClick: handleIconClick, children: icon }))] }), maxLength && (_jsx(MaxLengthContainer, { "data-testid": 'max-length-counter', children: `${value?.toString().length ?? 0}/${maxLength}` }))] }));
}));
Input.displayName = 'Input';
